import React from 'react';
import { BookOpenIcon, GiftIcon, StethoscopeIcon, UsersIcon } from 'lucide-react';
const items = [{
  icon: BookOpenIcon,
  label: '9 comprehensive volumes'
}, {
  icon: GiftIcon,
  label: '5 exclusive bonuses'
}, {
  icon: StethoscopeIcon,
  label: '+450 ready-to-use resources'
}, {
  icon: UsersIcon,
  label: 'Teachers, students and educators'
}];
export function SocialProof() {
  return <section className="border-y border-gold/50 bg-steel py-5" aria-label="What the teacher ready includes" data-id="element-234" data-mp="3ebm5a6drpy1">
      <div className="mx-auto flex max-w-5xl flex-wrap items-center justify-center gap-x-8 gap-y-3 px-4 text-sm font-semibold text-white sm:justify-between" data-id="element-235" data-mp="8e7rbcqtdnf6">
        {items.map(({
        icon: Icon,
        label
      }) => <span key={label} className="inline-flex items-center gap-2" data-id="element-236" data-mp="3ushdrgb6oldb">
            <Icon className="h-5 w-5 text-mineral" aria-hidden="true" data-id="element-237" data-mp="mdz81l8pthwv" /> {label}
          </span>)}
      </div>
    </section>;
}